<template>
  <el-dialog :visible.sync="visible" title="设置" custom-class="wiki_nikke_blackbox_setting" @closed="onClosed">
    <el-form :model="formModel">
      <el-form-item label="收菜提醒微信通知">
        <el-switch v-model="formModel.collect_notice" active-color="#409EFF" inactive-color="#C0CCDA"></el-switch>
      </el-form-item>
      <el-form-item>
        <div slot="label" class="label-wrapper">
          <div>每日任务忘做提醒微信通知</div>
          <div class="sub-label">注：每日任务在当日20:00未能完成时自动通知</div>
        </div>
        <el-switch v-model="formModel.task_notice" active-color="#409EFF" inactive-color="#C0CCDA"></el-switch>
      </el-form-item>
      <el-form-item class="tag-list-form-item">
        <div slot="label" class="label-wrapper">
          <div>游戏标签展示</div>
          <div class="sub-label">注：根据当前游戏数据自动生成游戏标签</div>
        </div>
        <el-switch v-model="formModel.tag_show" active-color="#409eff" inactive-color="#c0ccda"></el-switch>
      </el-form-item>
      <el-form-item>
        <div class="tag-select-wrapper">
          <div
            v-for="tag in tagList"
            :key="tag.id"
            class="tag-item"
            :style="{
              'background-image': `${
                tag.id === formModel.box_tag_id
                  ? 'url(' + require('@/assets/black_imgs/tag-border.png') + ')'
                  : 'initial'
              }`
            }"
            @click="formModel.box_tag_id = tag.id"
          >
            <img class="inner" :src="tag.icon" :alt="tag.name" />
          </div>
        </div>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <div class="button cancel" @click="$emit(status)">返回</div>
      <div class="button confirm" @click="handleSubmit">确定</div>
    </template>
  </el-dialog>
</template>
<script>
import { apiBoxSettingRead, apiBoxSettingUpdate } from "@/api/blackBoxApi";

export default {
  name: "SettingForm",
  props: {},
  data() {
    return {
      status: "reject",
      visible: false,
      formModel: {},
      tagList: []
    };
  },
  created() {
    this.fetchFormModel();
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    async fetchFormModel() {
      const { code, data } = await apiBoxSettingRead();
      if (code === 0) {
        this.formModel = data.config || {};
        this.tagList = data.tag_list || [];
      }
    },
    onClosed() {
      this.$emit(this.status);
    },
    async handleSubmit() {
      const { code, data } = await apiBoxSettingUpdate(this.formModel);
      if (code === 0) {
        console.log(data);
        this.status = "resolve";
        this.visible = false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .wiki_nikke_blackbox_setting {
  width: 555px;
  border-radius: 8px;
  .el-dialog__header {
    text-align: center;
    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: rgba(51, 51, 51, 0.9);
    }
    i.el-dialog__close {
      font-weight: bold;
    }
  }
  .el-form-item {
    box-sizing: content-box;
    margin: 0;
    padding: 14px 0;
    border-bottom: 1px solid #edeff5;
    .el-form-item__label {
      color: #333333;
      font-size: 14px;
    }
    .el-form-item__content {
      text-align: right;
    }
  }
  .tag-list-form-item {
    border-bottom-width: 0;
  }
  .el-dialog__footer {
    display: flex;
    justify-content: space-between;
    .button {
      width: 235px;
      line-height: 40px;
      text-align: center;
      border: 1px solid;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
    .cancel {
      background-color: #ffffff;
      color: #3490e6;
    }
    .confirm {
      background-color: #3490e6;
      color: #ffffff;
    }
  }
}
.label-wrapper {
  text-align: left;
  font-size: 14px;
  .sub-label {
    font-size: 12px;
    color: rgba(51, 51, 51, 0.7);
    line-height: 1;
  }
}
.tag-select-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 8px;
  .tag-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 125px;
    height: 37px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .inner {
      width: 115px;
      height: 24px;
    }
  }
}
</style>
